<template>
  <div class="index_top" :style='bgStyle'>
    <div class="container-w" :class="{active: active}">
      <div class="container">
        <div class="top_menu">
          <div class="laguage">
           <span v-if="getIndexData.sysLanguage==1" :class="{active: langType==1}" @click="language(1)">English</span>
           <span v-if="getIndexData.sysLanguage==1" class="line"></span>
            <span :class="{active: langType==0}" @click="language(0)">中文</span>
          </div>
          <div class="logo" :style='logoStyle'></div>
          <div class="nav_items">
            <div class="item" v-for='(i,k) in navItems' :key='k' :class="{active: curnavidx===k}"
                 @click="navigation(i.key, k)">{{langType==1?i.nameEn:i.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="des-text">网站建设中...</div> -->
  </div>
</template>


<script>
  import {mapGetters} from 'vuex'
  let strategy = {
    index() {
      this.$router.push({name: 'index'})
    },
    information() {
      this.$router.push({name: 'message'})
    },
    cases() {
      //
      this.$router.push('/cases/0')
    },
    elite() {
      //
      this.$router.push({name: 'parner'})
    },
    consumer() {
      // this.$router.push({name: 'consumerIndex'})
      this.$router.push('/consumer/0')
    },
    activity() {
      this.$router.push({name: 'commentIndex'})
    },
    recruit() {
      this.$router.push({name: 'joinIndex'})
    }
  }

  let activemap = {
    'information': 1,
    'cases': 2,
    'elite': 3,
    'consumer': 4,
    'activity': 5,
    'recruit': 6,
  }

  export default {
    data: () => ({
      langType: 0,
      active: false, // 顶部白色留白
      curnavidx: 0,
      navItems: [
        {name: '首页', nameEn: 'home page', key: 'index'},
        {name: '我们的讯息', nameEn: 'message', key: 'information'},
        {name: '我们的业务', nameEn: 'business', key: 'cases'},
        {name: '我们的精英', nameEn: 'elite', key: 'elite'},
        {name: '我们的客户', nameEn: 'customer', key: 'consumer'},
        {name: '我们的评述', nameEn: 'commentary', key: 'activity'},
        {name: '加入我们', nameEn: 'Join us', key: 'recruit'},
      ],
    }),
    computed: {
      ...mapGetters(['getIndexData']),
      bgStyle() {
        return {
          background: `url(${require('img/top_bg.png')}) no-repeat`,
          backgroundSize: '100% 100%'
        }
      },
      logoStyle() {
        return {
          background: `url(${require('img/logo.png')}) no-repeat`, backgroundSize: '100% 100%'
        }
      }
    },
    watch: {
      '$route': {
        immediate: true,
        handler(newVal) {
          this.active = true

          let p = newVal.path
          if (p.match('information')) {
            this.curnavidx = activemap.information
          } else if (p.match('cases')) {
            this.curnavidx = activemap.cases
          } else if (p.match('elite')) {
            this.curnavidx = activemap.elite
          } else if (p.match('consumer')) {
            this.curnavidx = activemap.consumer
          } else if (p.match('activity')) {
            this.curnavidx = activemap.activity
          } else if (p.match('recruit')) {
            this.curnavidx = activemap.recruit
          } else {
            this.active = false
            this.curnavidx = 0
          }
        }
      }
    },
    methods: {
      navigation(key, idx) {
        if (strategy[key]) {
          strategy[key].call(this)
        }
      },
      language(en) {
        this.langType ^= 1
        if (en == 0) {
          this.$store.commit('setLang', 'zh')
          localStorage.setItem('langType', 'zh')
        }
        if (en == 1) {
          this.$store.commit('setLang', 'en')
          localStorage.setItem('langType', 'en')
        }
        location.reload();
        // this.$$$api.cl({lang: eng ? 'en' : 'zh'}).then(() => {
        // location.reload()
        // })
      },
      handleInitLang(lang){
        // if (lang == 0) {
        //   this.$store.commit('setLang', 'zh')
        //   localStorage.setItem('langType', 'zh')
        // }
        // if (lang == 1) {
        //   this.$store.commit('setLang', 'en')
        //   localStorage.setItem('langType', 'en')
        // }
      }
    },
    created() {
      this.handleInitLang(this.getIndexData.sysLanguage)
      if (localStorage.getItem('langType')) {
        if (localStorage.getItem('langType') == 'zh') {
          this.langType = 0;
        } else {
          this.langType = 1
        }
        return
      }
      this.langType = 0
    }
  }
</script>


<style lang="stylus" scoped>
  @import "~styl/mixin.styl"

  fc = rgb(86, 86, 86)

  .index_top
    fs(0)
    height 500px
    position relative

    .des-text
      position absolute
      fs(35)
      c(red)
      left 30%
      top 170px
      c(#fff)
      font-weight 700

    .container-w.active
      bg(#fff)
      pb(20)

    .container
      container()
      oh()

      .top_menu
        ppr()
        mt(50)
        h(55)
        _flex()

        .laguage
          ppa()
          top 0
          right 10px
          h(25)
          lh(25)
          transform translateY(-100%)

          .line
            padding-top 15px
            border-left 1px solid fc
            ml(8)
            mr(8)
            fs(0)
            d(inline-block)
            transform translateY(2px)

          span
            fs(12)
            _hover()

            &.active
              c(gray)
              text-decoration underline

        .logo
          hh()
          w(415)

        .nav_items
          _flex()
          hh()

          .item
            pl(20)
            pr(20)
            pt(4)
            pb(4)
            fs(14)
            _hover()
            c(fc)
            border-radius 2px

            &.active
              c(#fff)
              bg(rgb(247, 170, 5))


</style>



// WEBPACK FOOTER //
// src/components/index/index_top.vue